import { IAcademyLink } from '@sdk/contracts';

import { PurpleIconWrapper } from '../../../shared/WidgetShared.styles';

import { TitleWrapper } from './LinkRow.styles';

import { Icon } from '@/components/Icon';

export const LinkRow: React.FC<IAcademyLink> = ({ link, info }) => (
  <TitleWrapper>
    <PurpleIconWrapper>
      <Icon i="Link" color="purple7" />
    </PurpleIconWrapper>
    <a href={link} target="_blank" rel="noopener noreferrer">
      {info || link}
    </a>
  </TitleWrapper>
);
